import PropTypes from "prop-types";
import styles from "./index.css";
import classnames from "classnames";
import useFocusableRef from "./useFocusableRef.js";

const Select = ({
  id,
  className,
  disabled,
  options,
  label,
  value,
  onChange,
  focus,
  onBlur,
  hasError
}) => {
  const hasOptions = options.length > 1;
  const selectRef = useFocusableRef({ focus });

  return (
    <div
      className={classnames(className, styles.select, {
        [styles.disabled]: disabled,
        [styles.hasOptions]: hasOptions,
        [styles.error]: hasError
      })}
    >
      <select
        id={id}
        ref={selectRef}
        disabled={disabled}
        aria-label={label}
        onChange={onChange}
        onBlur={onBlur}
        value={value}
      >
        {options.map(({ text, value: optionValue }) => (
          <option key={optionValue} value={optionValue}>
            {text}
          </option>
        ))}
      </select>
      {hasOptions ? <span className={styles.indicator} /> : undefined}
    </div>
  );
};

Select.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    })
  ).isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  focus: PropTypes.bool,
  onBlur: PropTypes.func,
  hasError: PropTypes.bool
};

export default Select;
